import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import { store } from "../Redux/store";
import Swal from "sweetalert2";

export default function DialogComponent(props) {
  const [open, setOpen] = React.useState(false);
  const [optionArray, setOptionArray] = React.useState(new Set());
  React.useEffect(() => {
    props.options.map(async (option) => {
      console.log(props.options, "17");
      isCheck(option).then((data) => {
        if (!data.isRewardClaimed) {
          console.log(option, "20");
          setOptionArray((optionArray) => new Set([...optionArray, option]));
        }
      });
    });
  }, [props.options]);

  const handleClickToOpen = () => {
    setOpen(true);
    optionArray.forEach((d) => console.log(d));
  };

  const handleToClose = () => {
    setOpen(false);
  };
  const isCheck = async (index) => {
    let user = await props.StackContract.methods
      .users(store.getState().ConnectivityReducer.metamaskAddress, index)
      .call();
    return user;
  };
  const Claim = async (index) => {
    props.setIsLoading(true);
    console.log(index);
    let data = await isCheck(index);
    if (data.isRewardClaimed) {
      handleToClose();
      props.setIsLoading(false);
      Swal.fire("Already Claimed");
    } else {
      handleToClose();

      props.StackContract.methods
        .claimReward(index)
        .send({ from: store.getState().ConnectivityReducer.metamaskAddress })
        .on("transactionHash", function (transactionHash) {
          console.log(transactionHash);
        })
        .on("confirmation", () => {})
        // get New Contract Address

        .then(async () => {
          handleToClose();
          await props.StackContract.methods
            .userTotalStake(
              store.getState().ConnectivityReducer.metamaskAddress
            )
            .call()
            .then((res) => {
              console.log(res);
              props.setStackTotalBalance(res / Math.pow(10, 18));
              Swal.fire("Transaction Successful", "", "success");
            });

          await props.StackContract.methods
            .stakeIndex(store.getState().ConnectivityReducer.metamaskAddress)
            .call()
            .then(async (res) => {
              let data = 0;
              for (let index = 1; index <= res; index++) {
                data =
                  data +
                  (await totalRewards(index, props.StackContract)) /
                    Math.pow(10, 18);
              }
              console.log(data);
              props.setStackRewardBalance(data);
            });

          props.setIsLoading(false);
        })

        .catch((err) => {
          handleToClose();
          props.setIsLoading(false);
          // Swal.fire("Transaction Failed", "", "error");
        });
    }
  };
  async function totalRewards(index, stackContract) {
    let data = await stackContract.methods
      .users(store.getState().ConnectivityReducer.metamaskAddress, index)
      .call();
    return parseFloat(data.rewardEarned);
  }
  async function handleUnstack(index) {
    props.setIsLoading(true);
    let data = await isCheck(index);
    if (data.isPoolBalClaimed) {
      handleToClose();
      props.setIsLoading(false);

      Swal.fire("Already Claimed");
    } else {
      handleToClose();
      props.StackContract.methods
        .claimPool(index + 1)
        .send({
          from: store.getState().ConnectivityReducer.metamaskAddress,
        })
        .on("transactionHash", function (transactionHash) {
          console.log(transactionHash);
        })
        .on("confirmation", () => {})
        // get New Contract Address
        .then(async () => {
          await props.StackContract.methods
            .userTotalStake(
              store.getState().ConnectivityReducer.metamaskAddress
            )
            .call()
            .then((res) => {
              console.log(res);
              props.setStackTotalBalance(res / Math.pow(10, 18));
              Swal.fire("Transaction Successful", "", "success");
            });
          handleToClose();
          Swal.fire("Transaction Successful", "", "success");
          props.setIsLoading(false);
        })
        .catch((err) => {
          props.setIsLoading(false);
          Swal.fire("Transaction Failed", "", "error");
        });
    }
  }
  return (
    <div
      stlye={{
        textAlign: "center",
      }}
    >
      <button
        style={{
          backgroundColor: "transparent",
          display: "flex",
          justifyContent: "center",
          width: "100%",
          textAlign: "center",
        }}
        onClick={handleClickToOpen}
      >
        {props.type === "stack" ? "Claim reward" : "Unstake"}
      </button>

      <Dialog open={open} onClose={handleToClose}>
        {[...optionArray].sort().map((option, index) => (
          <DialogContent style={{ overflowY: "none" }} key={index}>
            {console.log(option - 1)}
            <div
              style={{
                display: "flex",
                gap: "24px",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div key={index}>
                {" "}
                {props.type === "stack" ? "Claim Reward " : "Unstake"}
                {option}
              </div>
              <button
                onClick={
                  props.type === "stack"
                    ? () => Claim(option)
                    : () => handleUnstack(index)
                }
                style={{
                  padding: 6,
                  borderRadius: 30,
                  background: "#dd6f20",
                  textAlign: "center",
                  fontFamily: "Industry-Medium, serif",
                  fontSize: 14,
                }}
              >
                Claim
              </button>
            </div>
          </DialogContent>
        ))}
        <Button
          onClick={handleToClose}
          color="primary"
          style={{ backgroundColor: "#dd6f20", color: "white" }}
          autoFocus
        >
          Close
        </Button>
      </Dialog>
    </div>
  );
}

// stackContract.methods
//         .userTotalStake(store.getState().ConnectivityReducer.metamaskAddress)
//         .call()
//         .then((res) => {
//           console.log(res);
//           setStackTotalBalance(res / Math.pow(10, 18));
